import { CHANGE_BREAKPOINT } from '../constants'

export default function changeBreakpoint(device) {
  return {
    type: CHANGE_BREAKPOINT,
    device
  }
}



// WEBPACK FOOTER //
// ./src/actions/changeBreakpointActions.js